import Poll from './Poll.container';

export default Poll;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/poll/index.js